import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './helpers/auth.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'login',
    loadChildren: () => import('./views/login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'home',
    loadChildren: () => import('./views/home/home.module').then( m => m.HomePageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'parking-rules',
    loadChildren: () => import('./views/parking-rules/parking-rules.module').then( m => m.ParkingRulesPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'towing-company',
    loadChildren: () => import('./views/towing-company/towing-company.module').then( m => m.TowingCompanyPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'subscription',
    loadChildren: () => import('./views/subscription/subscription.module').then( m => m.SubscriptionPageModule)
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
